<template>
  <div
    style="
      display: flex;
      flex-direction: column;
      height: calc(100vh - 120px);
      gap: 12px;
    "
  >
    <div style="display: flex; justify-content: space-between; align-items: center">
      <h1 class="h3" style="margin-bottom: 0">
        {{ $t('export_history_page.title') }}
      </h1>
    </div>

    <!-- comment until working on filter
    <div class="position-relative mb-3">
      <div class="position-absolute mt-2 pbz-font body-md-bold">
        {{ $t('export_history_page.title') }}
      </div>
      <div class="d-flex justify-content-center align-items-center">
        <a-input-search
          class="col-4"
          allow-clear
          size="large"
          :placeholder="$t('utils.search')"
          :value="querySearch"
          @change="onSearch"
        />
        <a-button
          size="large"
          icon="filter"
          class="ml-2"
          @click="showModalFilter = true"
        >
          {{ $t('utils.filter') }}
        </a-button>
      </div>
    </div> -->

    <div class="mb-2">
      <a-button
        v-for="state in STATES"
        :key="state"
        shape="round"
        :class="['px-4 mr-2 tab-status-btn', activeStatus === state ? 'tab-active' : 'tab-inactive']"
        @click="changeRoute({ status: state, page: 1 })"
      >
        {{ $t('export_history_page.' + state) }}
      </a-button>
    </div>

    <div>
      <a-table
        style="border: 1px solid #e4e9f0; border-radius: 5px"
        size="middle"
        class="data-list"
        :data-source="data"
        :columns="columns"
        row-key="id"
        :loading="loadingList"
        :pagination="false"
        :locale="{ emptyText: $t('order.empty_title') }"
        :scroll="scroll"
        :custom-row="
          record => ({ on: { click: () => openDetailRequest(record) } })
        "
      >
        <template slot="menu" slot-scope="text">
          <a-tooltip :title="text === 'Sales' ? $t('export_history_page.sales') : (text || '-')">
            <span class="text-dark" style="font-weight: 500; vertical-align: middle;">
              {{ text === 'Sales' ? $t('export_history_page.sales') : (text || '-') }}
            </span>
          </a-tooltip>
        </template>

        <template slot="date" slot-scope="text">
          <span v-if="text" class="text-nowrap pbz-font text-dark">
            {{ fmtDate(text) }}
          </span>
        </template>

        <template slot="date_completed" slot-scope="text">
          <span v-if="text" class="text-nowrap pbz-font text-dark">
            {{ fmtDate(text) }}
          </span>
          <span v-else class="text-muted">-</span>
        </template>

        <template slot="status" slot-scope="text">
          <span v-if="text" :class="['status-badge', 'status-' + String(text).toLowerCase()]">
            <span class="status-dot" />
            {{ $t('export_history_page.' + String(text).toLowerCase()) }}
          </span>
          <span v-else>-</span>
        </template>

        <template slot="user" slot-scope="text">
          <a-tooltip :title="text || '-'">
            <span class="text-dark" style="font-weight: 500; vertical-align: middle;">
              {{ text || '-' }}
            </span>
          </a-tooltip>
        </template>

        <template slot="file_export" slot-scope="text, record">
          <span class="d-inline-flex align-items-center mw-100" @click.stop>
            <template v-if="record.status === 'ON_PROGRESS'">
              <span class="file-pill-generating">
                <a-icon type="loading" class="mr-2" />
                <span class="generating-text text-truncate">{{ $t('export_history_page.generating') || 'Generating file...' }}</span>
              </span>
            </template>
            <template v-else-if="record.status === 'FAILED' || !record.url">
              <span class="text-muted fs-12">-</span>
            </template>
            <template v-else>
              <a-tooltip :title="record.file_name">
                <a
                  class="file-pill-download"
                  @click.prevent="download(record.url)"
                >
                  <a-icon type="file-excel" class="excel-icon" />
                  <span class="file-name text-truncate">{{ record.file_name }}</span>
                  <a-icon type="download" class="download-icon" />
                </a>
              </a-tooltip>
            </template>
          </span>
        </template>

        <template slot="action" slot-scope="text, record">
          <div @click.stop>
            <a-dropdown placement="bottomRight">
              <a @click.stop.prevent="">
                <a-icon type="more" />
              </a>
              <a-menu slot="overlay">
                <a-menu-item @click="openDetailRequest(record)">
                  <a-icon type="eye" class="mr-2" />
                  {{ $t('export_history_page.details') || 'Details' }}
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </div>
        </template>

        <template slot="footer">
          <a-pagination
            v-model="currentPage"
            style="display: flex; justify-content: flex-end"
            :page-size="pageSize"
            :page-size-options="['10', '20', '50', '100']"
            :total="total_row"
            :show-total="
              (total, range) =>
                $t('utils.pagination_show_total', {
                  perpage: `${range[0]} - ${range[1]}`,
                  total,
                })
            "
            :locale="{ items_per_page: $t('utils.items_per_page') }"
            :disabled="loadingList"
            show-size-changer
            @change="page => changeRoute({ page })"
            @showSizeChange="onShowSizeChange"
          />
        </template>
      </a-table>
    </div>

    <ShowDetailRequest :visible.sync="showDetailVisible" :data="detailData" />

    <template v-if="!loadingList">
      <ErrorInfo v-if="errorRows" :error-type="errorRows" />
      <EmptyInfo
        v-else-if="!data.length"
        class="py-5"
        :title="$t('order.empty_title')"
      />
    </template>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import EmptyInfo from '@/components/EmptyInfo'
import ErrorInfo from '@/components/ErrorInfo'
import { getListExportHistory } from '@/api/dashboard'
import ShowDetailRequest from './ShowDetailRequest.vue'
import { getChannelsByBusinessList } from '@/api/business'


export default defineComponent({
  components: {
    EmptyInfo,
    ErrorInfo,
    ShowDetailRequest,
  },
  data() {
    return {
      STATES: ['all', 'finished', 'on_progress', 'failed'],
      THEAD: [
        { label: 'date', width: 100 },
        { label: 'user', width: 170 },
        { label: 'menu', width: 170 },
        { label: 'date_completed', width: 160 },
        { label: 'status', width: 150 },
        { label: 'file_export', width: 300 },
      ],
      data: [],
      total_row: 0,
      errorRows: false,
      loadingList: false,
      itemExport: {},
      showModalFilter: false,
      querySearch: '',
      showDetailVisible: false,
      detailData: {},
      STATE_COLOR_TAG: {
        ON_PROGRESS: 'blue',
        FINISHED: 'green',
        FAILED: 'red',
      },
      salesChannelNameById: {},
      salesChannelNameByCode: {},
      
      channelTitleById: {},
      channelTitleByCode: {},
      channelTitleByTitle: {},
    }
  },
  computed: {
    scroll() {
      return {
        x: '100%',
      }
    },
    currentPage: {
      get() {
        return +this.$route.query.page || 1
      },
      set(val) {
        this.changeRoute({ page: val })
      },
    },
    activeStatus() {
      return this.$route.query.status || 'all'
    },
    pageSize() {
      return +this.$route.query.limit || 10
    },
    permission() {
      return this.$store.getters['user/can'](this.$route.meta.key)
    },
    columns() {
      return [
        {
          title: this.$t('export_history_page.date'),
          dataIndex: 'created_at',
          key: 'date',
          width: 170,
          scopedSlots: { customRender: 'date' },
        },
        {
          title: this.$t('export_history_page.date_completed'),
          dataIndex: 'completed_at',
          key: 'date_completed',
          width: 170,
          scopedSlots: { customRender: 'date_completed' },
        },
        {
          title: this.$t('export_history_page.status'),
          dataIndex: 'status',
          key: 'status',
          width: 150,
          scopedSlots: { customRender: 'status' },
        },
        {
          title: this.$t('export_history_page.file_export'),
          dataIndex: 'file_name',
          key: 'file_export',
          width: 300,
          scopedSlots: { customRender: 'file_export' },
        },
        {
          title: this.$t('export_history_page.menu'),
          dataIndex: 'menu',
          key: 'menu',
          ellipsis: true,
          scopedSlots: { customRender: 'menu' },
        },
        {
          title: this.$t('export_history_page.user'),
          dataIndex: 'user',
          key: 'user',
          ellipsis: true,
          scopedSlots: { customRender: 'user' },
        },
        {
          title: '',
          key: 'action',
          width: 50,
          align: 'right',
          scopedSlots: { customRender: 'action' },
        },
      ]
    },
  },
  watch: {
    '$route.query'() {
      this.getList()
    },
  },
  mounted() {
    this.getList()
  },
  methods: {
    fmtDate(iso) {
      if (!iso) return ''
      try {
        if (this.$moment) return this.$moment(iso).format('DD MMM YYYY - HH.mm')
        const d = new Date(iso)
        if (isNaN(d)) return ''
        return d.toLocaleString(undefined, {
          day: '2-digit',
          month: 'short',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          hour12: false,
        }).replace(':', '.')
      } catch {
        return ''
      }
    },

    async getList() {
      const { q, page, status, limit } = this.$route.query

      this.loadingList = true
      this.data = []
      this.total_row = 0
      this.errorRows = false
      this.querySearch = q || ''

      try {
        const params = {
          page: Number(page) || 1,
          limit: Number(limit) || this.pageSize,
        }
        if (q && q.trim()) params.q = q.trim()
        if (status && status !== 'all') {
          params.state = status.toUpperCase()
        }

        const resp = await getListExportHistory({ params })
        const body = (resp && resp.data) ? resp.data : resp
        const rows = Array.isArray(body?.data) ? body.data.filter(Boolean) : []

        this.data = rows.map(r => ({
          id: r.id,
          created_at: r.created_at,
          user: r.user_name,
          menu: r.source,
          file_name: r.file_name || (r.url ? r.url.split('/').pop() : ''),
          url: r.url || null,
          status: r.state ? String(r.state).toUpperCase().replace(/\s+/g, '_').replace('ON_PROCESS', 'ON_PROGRESS') : '',
          param: r.param || null,
          completed_at: r.completed_at || null,
          business_name_list: Array.isArray(r.business_name_list) ? r.business_name_list : [],
          warehouse_name_list: Array.isArray(r.warehouse_name_list) ? r.warehouse_name_list : [],
          sales_channel_name_list: Array.isArray(r.sales_channel_name_list) ? r.sales_channel_name_list : [],
          workspaces_name: r.workspaces_name || null,
        }))


        this.total_row = Number(
              (body && (body.total_rows ?? body.record ?? rows.length)) || 0,
        )
      } catch (e) {
        console.error('[ExportHistory] API error', e?.response || e)
        this.errorRows = 'server'
      } finally {
        this.loadingList = false
      }
    },

    onSearch(e) {
      const value = e.target.value
      this.querySearch = value
      if (this.timeout) clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        const valTrim = value.trim()
        const { workspace_id, business_id, q } = this.$route.query
        if (q !== valTrim) {
          this.changeRoute({
            page: undefined,
            q: valTrim.length ? valTrim : undefined,
          })
        }
      }, 500)
    },

    changeRoute(q) {
      const query = { ...this.$route.query, ...q }

      // Remove undefined/null/empty keys to keep URL clean
      Object.keys(query).forEach(key => {
        if (query[key] === undefined || query[key] === null || query[key] === '') {
          delete query[key]
        }
      })

      const currentQuery = this.$route.query
      const isSame = Object.keys(query).length === Object.keys(currentQuery).length &&
        Object.keys(query).every(key => String(query[key]) === String(currentQuery[key]))

      if (!isSame) {
        this.$router.push({ query }).catch(() => {})
      }
    },

    onShowSizeChange(current, size) {
      this.changeRoute({ page: 1, limit: size })
    },

    tryAgainExport(val) {
      this.itemExport = val
      setTimeout(() => {
        this.itemExport = {}
      }, 2000)
    },

    download(url) {
      if (!url) return
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', '')
      link.style.display = 'none'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },

    toArray(v) {
      if (Array.isArray(v)) return v
      if (v === null || v === undefined || v === '') return []
      return [v]
    },
    normalizeDetailParam(p) {
      if (!p || typeof p !== 'object') return {}
      const idList = this.toArray(p.businessId)

      return {
        dateFrom: p.dateFrom || null,
        dateUntil: p.dateUntil || null,

        businessId: idList.map(String),

        businessIdRaw: idList,

        workspaceId: p.workspaceId || null,
        currencyCode: this.toArray(p.currencyCode),

        warehouseId: this.toArray(p.warehouseId),
        salesChannelId: this.toArray(p.salesChannelId),
        channelId: this.toArray(p.channelId),
      }
    },


    asArray(resp) {
      if (Array.isArray(resp)) return resp
      if (Array.isArray(resp?.data)) return resp.data
      if (Array.isArray(resp?.data?.data)) return resp.data.data
      return []
    },

    async ensureChannelsLoaded(businessIds = []) {
      const uniq = Array.from(new Set(businessIds.filter(Boolean)))
      if (!uniq.length) return

      try {
        const results = await Promise.all(
          uniq.map(bid =>
            getChannelsByBusinessList({ business_id: bid, status: 'CONNECTED' }),
          ),
        )

        results.forEach(resp => {
          const list = this.asArray(resp)
          list.forEach(item => {
            if (item.sales_channel_id != null) {
              this.salesChannelNameById[item.sales_channel_id] = item.sales_channel_name
            }
            if (item.sales_channel_code) {
              this.salesChannelNameByCode[item.sales_channel_code] = item.sales_channel_name
            }
            if (item.id != null) {
              this.channelTitleById[item.id] = item.channel_title
            }
            if (item.channel_code) {
              this.channelTitleByCode[item.channel_code] = item.channel_title
            }
            if (item.channel_title) {
              this.channelTitleByTitle[item.channel_title.toLowerCase()] = item.channel_title
            }
          })
        })

        console.log('[ensureChannelsLoaded] salesChannelNameById:', this.salesChannelNameById)
        console.log('[ensureChannelsLoaded] salesChannelNameByCode:', this.salesChannelNameByCode)
        console.log('[ensureChannelsLoaded] channelTitleById:', this.channelTitleById)
        console.log('[ensureChannelsLoaded] channelTitleByCode:', this.channelTitleByCode)
      } catch (e) {
        console.error('[ensureChannelsLoaded] failed', e)
      }
    },

    mapSalesChannel(val) {
      if (val == null || val === '') return null
      const asNum = Number(val)
      if (!Number.isNaN(asNum) && this.salesChannelNameById[asNum]) {
        return this.salesChannelNameById[asNum]
      }
      if (this.salesChannelNameByCode[val]) return this.salesChannelNameByCode[val]
      return val
    },

    mapChannel(val) {
      if (val == null || val === '') return null
      const asNum = Number(val)
      if (!Number.isNaN(asNum) && this.channelTitleById[asNum]) {
        return this.channelTitleById[asNum]
      }
      if (this.channelTitleByCode[val]) return this.channelTitleByCode[val]
      const lower = String(val).toLowerCase()
      if (this.channelTitleByTitle[lower]) return this.channelTitleByTitle[lower]
      return val
    },

    async openDetailRequest(record) {
      const detail = this.normalizeDetailParam(record?.param)

      const businessIds = detail.businessIdRaw?.length
        ? detail.businessIdRaw
        : (this.$route.query.business_id ? [this.$route.query.business_id] : [])

      await this.ensureChannelsLoaded(businessIds)

      // Use record.sales_channel_name_list if available, otherwise fallback to mapping IDs
      const salesChannels = Array.isArray(record?.sales_channel_name_list) && record.sales_channel_name_list.length
        ? record.sales_channel_name_list
        : (Array.isArray(detail.salesChannelId)
          ? detail.salesChannelId.map(v => this.mapSalesChannel(v)).filter(v => v != null && v !== '')
          : [])

      const channels = Array.isArray(detail.channelId)
        ? detail.channelId.map(v => {
            const name = this.mapChannel(v)
            return name ? `${name} (${v})` : String(v)
          }).filter(v => v != null && v !== '')
        : []

      const businessNames = Array.isArray(record?.business_name_list) && record.business_name_list.length
        ? record.business_name_list
        : detail.businessId

      // Use record.warehouse_name_list if available, otherwise fallback to detail.warehouseId
      const warehouses = Array.isArray(record?.warehouse_name_list) && record.warehouse_name_list.length
        ? record.warehouse_name_list
        : (Array.isArray(detail.warehouseId) ? detail.warehouseId : [])

      this.detailData = {
        ...detail,
        businessId: businessNames,
        salesChannelId: salesChannels,
        channelId: channels,
        warehouseId: warehouses,
        workspaces_name: record?.workspaces_name || record?.workspaceId || detail.workspaceId,
      }
      this.showDetailVisible = true
    },


}
,
})
</script>

<style lang="scss" scoped>
::v-deep(.ant-table-body) {
  max-height: calc(100vh - 330px) !important;
  min-height: calc(100vh - 330px) !important;
}
::v-deep(.ant-table-content),
::v-deep(.ant-table-scroll) {
  position: relative !important;
}
::v-deep(.ant-table-placeholder) {
  position: absolute !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
  border: none !important;
  background: transparent !important;
  z-index: 10 !important;
}

.data-list {
  background: #ffffff;
  border-radius: 8px;
  overflow: hidden;

  ::v-deep(.ant-table-thead > tr > th) {
    background-color: #f0f2f4 !important;
    color: #475569 !important;
    font-weight: 600 !important;
    font-size: 12px !important;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    border-bottom: 1px solid #e4e9f0 !important;
    padding: 14px 16px !important;
  }

  ::v-deep(.ant-table-tbody > tr > td) {
    padding: 14px 16px !important;
    border-bottom: 1px solid #e4e9f0 !important;
    color: #334155;
    font-size: 13px;
  }

  ::v-deep(.ant-table-row) {
    cursor: pointer;
    transition: background-color 0.2s ease;
  }

  ::v-deep(.ant-table-row:hover > td) {
    background-color: #f8fafc !important;
  }
}

.status-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.5;
  white-space: nowrap;

  .status-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    margin-right: 8px;
    display: inline-block;
  }

  &.status-finished {
    background-color: #f6ffed;
    color: #52c41a;
    border: 1px solid #b7eb8f;
    .status-dot {
      background-color: #52c41a;
    }
  }

  &.status-on_progress {
    background-color: #e6f7ff;
    color: #1890ff;
    border: 1px solid #91d5ff;
    .status-dot {
      background-color: #1890ff;
    }
  }

  &.status-failed {
    background-color: #fff1f0;
    color: #ff4d4f;
    border: 1px solid #ffccc7;
    .status-dot {
      background-color: #ff4d4f;
    }
  }
}

.file-pill-download {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  border-radius: 16px;
  background-color: #f6ffed;
  border: 1px solid #b7eb8f;
  color: #217346;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.5;
  cursor: pointer;
  transition: all 0.2s ease;
  max-width: 100%;
  text-decoration: none !important;

  .excel-icon {
    font-size: 16px;
    color: #217346;
    flex-shrink: 0;
  }

  .file-name {
    flex: 1;
    max-width: 220px;
    color: #217346;
    text-decoration: none !important;
  }

  .download-icon {
    font-size: 13px;
    color: #217346;
    flex-shrink: 0;
    transition: transform 0.2s ease;
  }

  &:hover {
    background-color: #d9f7be;
    border-color: #95de64;
    color: #107c41;
    text-decoration: none !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

    .file-name {
      color: #107c41;
      text-decoration: none !important;
    }

    .download-icon {
      transform: translateY(1px);
      color: #107c41;
    }
  }
}

.file-pill-generating {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  border-radius: 16px;
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
  color: #64748b;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.5;
  max-width: 100%;
  cursor: default;
}

.tab-status-btn {
  font-size: 12px;
  font-weight: 500;
  height: 32px;
  transition: all 0.2s ease;

  &.tab-active {
    background-color: #e00000 !important;
    color: #ffffff !important;
    border-color: #e00000 !important;
  }

  &.tab-inactive {
    background-color: #ffffff !important;
    color: #1a1a1a !important;
    border-color: #e4e9f0 !important;

    &:hover {
      color: #e00000 !important;
      border-color: #e00000 !important;
    }
  }
}
.data-list .ant-table-body {
  max-height: calc(100vh - 370px) !important;
  overflow-y: auto !important;
}
</style>

